import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/modal";
import { refundPaymentPayout } from "api/payments";
import Card from "components/card";
import DivLoader from "components/divloader/DivLoader";
import React from "react";
import { toast } from "react-hot-toast";
import { MdOutlineReplayCircleFilled } from "react-icons/md";
import { convertToFloat } from "utils/formatNumber";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader , PopoverArrow } from "@chakra-ui/react";
import { Portal } from '@chakra-ui/portal'

const RefundModal = ({
  info,
  fetchPayments,
  transactionID,
  varient,
  enRefund,
  client_is_deleted,

}: {
  info?: any;
  fetchPayments: () => void;
  transactionID: string;
  varient?: string;
  enRefund?: any;
  client_is_deleted?: boolean;

}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = React.useState<boolean>();
  const handleClose = () => {
    onClose();
  };
  async function handleRefund(data: any) {
    setIsLoading(true);
    refundPaymentPayout(data,null)
      .then((resp: any) => {
        if (resp?.message?.status === "REFUNDED") {
          toast.success("Successfully refunded");
        } else if (resp?.message?.status === "REFUND DECLINED") {
          toast.success("Refund declined form the gateway");
        } else {
          toast.error("Refund failed");
        }
        onClose();
        fetchPayments();
      })
      .catch((err: any) => {
        toast.error(
          err?.response?.data?.error ?? "Unable refund this transaction"
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  }
  return (
    <>
      <Popover trigger="hover" placement="bottom">
        <PopoverTrigger>
          <span className="inline-flex">
            <button
              className="outline-none disabled:cursor-not-allowed disabled:opacity-50"
              onClick={onOpen}
              disabled={ 
                client_is_deleted ||
                info?.client === "Banwire" ||
                info?.et_id?.includes("payout") ||
                info?.status === "REFUNDED" ||
                info?.status === "ERRORED" ||
                info?.status === "DECLINED" ||
                info?.status === "CREATED" ||
                info?.status === "AUTHORIZED" ||
                info?.status === "CANCELLED" ||
                info?.status === "PENDING" ||
                info?.status === "HELD" ||
                info?.status === "DISPUTE" ||
                info?.status === "REJECTED" ||
                info?.status === "CHARGEBACK" ||
                info?.status === "FAILED" ||
                !enRefund
                  ? true
                  : false
              }
            >
              <MdOutlineReplayCircleFilled
                className={
                  varient === "small"
                    ? "h-[21px] w-[21px] text-blue-500"
                    : "h-6 w-6 text-blue-500"
                }
              />
            </button>
          </span>
        </PopoverTrigger>  
        <Portal > 
          <PopoverContent borderColor='blue.800' className="z-20 dark:bg-gray-800 shadow  invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:border-gray-600 dark:bg-gray-800 p-3 border-6 shadow !bg-gray-700">
            <PopoverHeader>
              <span className="text-sm  font-bold text-white">
            Refund Payout
            </span>
            </PopoverHeader>
            <PopoverArrow  className="border h-8 w-8 border-gray-700 !bg-gray-700  "  />
          </PopoverContent>
        </Portal>
      </Popover>
      
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay className="bg-[#000] !opacity-30" />
        <ModalContent className="sm:max-w-xxl z-[1002] !m-auto flex min-h-[100vh] max-w-[800px] justify-center !p-3 sm:my-8 sm:w-full">
          <ModalBody>
            <Card extra=" max-w-[800px]   flex flex-col !z-[1004]">
              <h1 className="p-3 px-[30px] text-2xl font-bold">
                Refund Payment
              </h1>

              <div className="mx-[35px]">
                <p>
                  This will refund the transaction{" "}
                  <strong>{info?.et_id}</strong>. Do you want to continue?
                </p>
                <p className="mt-3 flex gap-1.5 text-xl">
                  Refund
                  <span className="text-xl font-bold uppercase">
                    {convertToFloat(info?.amount)} {info?.currency}
                  </span>
                  ?
                </p>
              </div>

              <div className="mt-5 flex gap-2 px-[30px] pb-[30px]">
                <button
                  onClick={handleClose}
                  className="linear rounded-xl bg-indigo-600 px-5 py-2 text-white font-medium text-navy-700 outline-none transition duration-200 hover:bg-indigo-500 active:bg-indigo-500 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                  // className="linear rounded-xl bg-gray-100 px-5 py-2 text-base font-medium text-navy-700 outline-none transition duration-200 hover:bg-gray-200 active:bg-gray-300 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                >
                  Close
                </button>
                <button
                  disabled={client_is_deleted}

                  onClick={() => {
                    handleRefund({ transaction_id: transactionID });
                  }}
                  className="linear rounded-xl bg-indigo-600 px-5 py-2 text-base font-medium text-white outline-none transition duration-200 hover:bg-indigo-600 active:bg-indigo-600 dark:bg-indigo-400/10 dark:text-white dark:hover:bg-indigo-300/10 dark:active:bg-indigo-200/10"
                >
                  {isLoading ? (
                    <DivLoader className="mx-0 h-5 w-5 border-white px-0" />
                  ) : (
                    "Refund"
                  )}
                </button>
              </div>
            </Card>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
export default RefundModal;
